module.exports = __webpack_public_path__ + "img/pseson.657ea4ab.png";